module.exports = __webpack_public_path__ + "img/HCP-PREVAIL-I-&-II-Reprint.1693e57f.png";